import { Button, Flex, Title } from '@mantine/core'
import { Card, CardContent, Stack } from '@mui/material'
import { IconSquareRoundedPlus } from '@tabler/icons-react'
import { useState } from 'react'
import { useTranslate } from 'react-admin'
import { useNavigate } from 'react-router-dom'
import { useGetApiVideoPromotionOperations } from '../../codegen/generated/video-promotion'
import { VideosPromotionsOperationsFilters } from '../../components/VideosPromotions/VideosPromotionsOperationsFilters'
import { VideosPromotionsOperationsList } from '../../components/VideosPromotions/VideosPromotionsOperationsList'
import { useUserStore } from '../../stores/useUserStore'
import { IVideoPromotionStaticFilters } from '../../types/components/VideoPromotion.type'
import styles from './VideosPromotions.module.scss'

export const VideosPromotions = () => {
  const t = useTranslate()
  const navigate = useNavigate()
  const userStore = useUserStore()

  const [filters, setFilters] = useState<IVideoPromotionStaticFilters | undefined>()

  const videoPromotionOperationsQuery = useGetApiVideoPromotionOperations(filters)

  return (
    <Card>
      <CardContent className={styles.container}>
        <Stack spacing="xl">
          <Flex direction="row" justify="space-between" align="center" wrap="wrap">
            <Title order={1} size="h2">
              {t('pages.videoPromotion.promotionOperations')}
            </Title>
            <Button
              type="button"
              variant="filled"
              size="compact-md"
              onClick={() => navigate('/videosPromotions/new')}
              leftSection={<IconSquareRoundedPlus size={14} />}
              disabled={!userStore.isAuthorised('video_promotion.edit')}
            >
              {t('pages.videoPromotion.newOperation')}
            </Button>
          </Flex>
          <VideosPromotionsOperationsFilters
            isLoading={videoPromotionOperationsQuery.isLoading}
            onUpdate={setFilters}
          />
          <VideosPromotionsOperationsList
            operations={videoPromotionOperationsQuery.data?.body.operations ?? []}
            isLoading={videoPromotionOperationsQuery.isLoading}
          />
        </Stack>
      </CardContent>
    </Card>
  )
}
